;(function() {
/* @ngInject */
function RadioButtonController() {
    let vm = this;
}

angular.module("firmaren")
    .component("radioButton", {
        templateUrl: "/app/shared/radio-button/radio-button.html",
        controller: RadioButtonController,
        controllerAs: "vm",
        bindings: {
            model: "=",
            value: "<",
            label: "<",
            name: "<",
            required: "<"
        }
    });
}());
